// src/admin/components/StatusChip.tsx
import styles from './StatusChip.module.css';

type Tone = 'neutral' | 'positive' | 'warn' | 'danger' | 'info';

export default function StatusChip({ label, tone = 'neutral' }: { label: string; tone?: Tone }) {
  return <span className={`${styles.chip} ${styles[tone]}`}>{label}</span>;
}
